export default "__VITE_ASSET__CRn1A02n__"